import { useCallback, useEffect, useRef } from "react";

interface InfiniteScrollBottomProps {
  onBottomReached: () => void;
  isEnd: boolean;
  height?: string;
}

export const InfiniteScrollBottom = ({
  onBottomReached,
  isEnd,
  height,
}: InfiniteScrollBottomProps) => {
  const divRef = useRef<HTMLDivElement | null>(null);

  // On intersect called
  const onIntersect = useCallback(
    (entries: IntersectionObserverEntry[]) => {
      if (entries[0].isIntersecting && !isEnd) {
        onBottomReached();
      }
    },
    [onBottomReached, isEnd]
  );

  /*
   * Look for observations
   */
  useEffect(() => {
    const observer = new IntersectionObserver(onIntersect);
    if (divRef.current) {
      observer.observe(divRef.current);
    }
    return () => observer.disconnect();
  }, [onIntersect]);

  return <div ref={divRef} style={{ height: height ?? "1px" }} />;
};
